export const MINIMUM_DESCRIPTION_LENGTH = 10;
export const YOUTUBE_EMBED_URL = 'https://www.youtube.com/embed/';
export const ALL_SHADE_HEADER_TITLE = 'SELECT_A_SHADE';
export const ALL_SIZE_HEADER_TITLE = 'SELECT_A_SIZE';
export const DESCRIPTION_TAB = 'DESCRIPTION';
export const INGREDIENTS_TAB = 'INGREDIENTS';
export const HOW_TO_USE_TAB = 'HOW_TO_USE';
export const PRODUCT_DETAILS_TITLE = 'PRODUCT_DETAILS_TITLE';
export const VIEW_ALL_PRODUCTS = 'VIEW_ALL_PRODUCTS';
export const CUSTOMERS_ALSO_VIEWED = 'CUSTOMERS_ALSO_VIEWED';
export const CUSTOMERS_ALSO_BOUGHT = 'CUSTOMERS_ALSO_BOUGHT';
export const OFFERS_SECTION_ID = 'product-offers-section';
export const OFFERS_TAG_NAME = 'OFFERS';
export const OFFER_TAG_NAME = 'OFFER';
export const INCLUSIVE_TAX_TEXT = 'INCLUSIVE_TAX_TEXT';
export const INCLUSIVE_TAX_TEXT_SHORT = 'INCLUSIVE_TAX_TEXT_SHORT';
export const PRIMARY_ACTION_TEXT = 'GOT_IT';
export const CAV_SECTION_ID = 'cav-products-section';
export const VIEW_SIMILAR_TEXT = 'VIEW_SIMILAR';
export const DELIVERY_SECTION_ID = 'delivery-section';
export const CAB_SECTION_ID = 'cab-products-section';
export const EFFECTIVE_COUPON_ID = 'effective-coupon';
export const SIZE_SELECT_TEXT = 'SELECT_SIZE';
export const SIZE_CHART = 'SIZE_CHART';
export const ALL_SHADES = 'ALL_SHADES';
export const OFFERS_STATIC = 'OFFERS';
export const APP_HEADER = 'app-header';
export const PRODUCT_ATTRIBUTES = 'product-attributes';
export const MediaTypes = {
  VIDEO: 'video',
  YOUTUBE_VIDEO: 'youtube video',
  IMAGE: 'image',
};
export const WidgetType = {
  HIGHLIGHTS: 'highlights',
};
export const DEFAULT_OFF = 'Off!';
export const recommendationsTracking = 'recommendation';

export const pdpStripTracking = {
  FREE_SHIPPING_COD: 'free_shipping_cod_shown',
  FREE_SHIPPING: 'free_shipping_shown',
  COD: 'cod_shown',
  NOT_ELIGIBLE: 'Not_eligible',
  NO_VALUE: 'No Value',
};

export const CTAText = 'BUY_NOW';
export const REFERRAL_CODES_COOKIE = 'REFERRAL_CODES';
export const VIEW_SIMILAR_PRODUCT_COUNT = 6;
export const VERTICAL_RECO_WIDGET_COUNT = 6;
export const L3_CATEGORY_ID = 'category';

export const RECENTTY_VIEWED_PRODUCTS = 'RECENTTY_VIEWED_PRODUCTS';
export const RECENTLY_VIEWED_PRODUCTS_COUNT = 10;
export const RECENTLY_VIEWED_EXPIRY_DAYS = 30;

export const RECENTLY_VIEWED_SORT_ORDER = {
  LATEST_FIRST: 'latest_first',
  OLDEST_FIRST: 'oldest_first',
} as const;

export type RecentlyViewedSortOrder =
  (typeof RECENTLY_VIEWED_SORT_ORDER)[keyof typeof RECENTLY_VIEWED_SORT_ORDER];

export const priceFluctuationDataAvailable = 'priceFluctuationDataAvailable';
export const differentitalPricingVisible = 'differentitalPricingVisible';
export const priceFluctuationVisible = 'priceFluctuationVisible';
export const differentialSaleTimer = 'differentialSaleTimer';

export const pricingNudgeTrackingKeys = {
  isLowestPriceEverShown: false,
  isLowestPriceEverEligible: false,
  isFirstTimeOnDiscountShown: false,
  isFirstTimeOnDiscountEligible: false,
  isPriceDroppedShown: false,
  isPriceDroppedEligible: false,
};

export const templatesTrackingKeysMapping = {
  lowest_price_ever: {
    shown: 'isLowestPriceEverShown',
    available: 'isLowestPriceEverEligible',
  },
  price_dropped: {
    shown: 'isPriceDroppedShown',
    available: 'isPriceDroppedEligible',
  },
  first_discount: {
    shown: 'isFirstTimeOnDiscountShown',
    available: 'isFirstTimeOnDiscountEligible',
  },
};
export const baseline = 'baseline';

export const isLowestPriceEverShown = 'isLowestPriceEverShown';
export const isLowestPriceEverEligible = 'isLowestPriceEverEligible';
export const isPriceDroppedShown = 'isPriceDroppedShown';
export const isPriceDroppedEligible = 'isPriceDroppedEligible';
export const isFirstTimeOnDiscountShown = 'isFirstTimeOnDiscountShown';
export const isFirstTimeOnDiscountEligible = 'isFirstTimeOnDiscountEligible';
export const SIMILAR_PRODUCTS = 'SIMILAR_PRODUCTS';
export const VIEW_SIMILAR_PRODUCT_IMAGE_COUNT = 18;
export const SimilarProductsExpandTimer = 2000;
export const PRO = 'PRO';
export const appsFlyerLogs = {
  NO_CLICK_URL_FALLBACK: 'Click URL missing, fallback triggered.',
  CLICK_URL_SUCCESS: (url: string) => `Click URL resolved: ${url}`,
  SMART_SCRIPT_TIMEOUT: 'AppsFlyer Script timed out, fallback triggered.',
};
